<template>
  <main class="pageMain bg-hex-EFF6FE certificate-verify-page" :class="globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''">
    <!-- 内容区域 -->
    <div class="content-wrapper">
      <!-- 内容区域的蒙版背景 -->
      <div class="content-mask"></div>

      <h1 class="page-title">{{ globalDataArray.siteTemplateLanguage.certificate_verify || '证书真伪验证' }}</h1>

      <!-- 查询表单容器 -->
      <div class="search-container">
        <div class="form-row">
          <div class="form-item">
            <label>{{ globalDataArray.siteTemplateLanguage.name_text || '姓名' }}:</label>
            <div class="input-wrapper">
              <input
                v-model="searchForm.name"
                type="text"
                :placeholder="globalDataArray.siteTemplateLanguage.please_enter_name || '请输入姓名'"
                class="form-input"
                :class="{ 'error': validationErrors.name }"
                @input="clearValidationError('name')"
                @keyup.enter="handleVerify"
              >
              <div v-if="validationErrors.name" class="error-message">
                {{ validationErrors.name }}
              </div>
            </div>
          </div>
          <div class="form-item">
            <label>{{ globalDataArray.siteTemplateLanguage.certificate_number_label || '证书编号' }}:</label>
            <div class="input-wrapper">
              <input
                v-model="searchForm.certificateNumber"
                type="text"
                :placeholder="globalDataArray.siteTemplateLanguage.certificate_number_placeholder || '请输入证书编号'"
                class="form-input"
                :class="{ 'error': validationErrors.certificateNumber }"
                @input="clearValidationError('certificateNumber')"
                @keyup.enter="handleVerify"
              >
              <div v-if="validationErrors.certificateNumber" class="error-message">
                {{ validationErrors.certificateNumber }}
              </div>
            </div>
          </div>
          <div class="btn btn1" @click="handleVerify" :class="{ disabled: isLoading }">
            {{ isLoading ? (globalDataArray.siteTemplateLanguage.verifying || '验证中...') : (globalDataArray.siteTemplateLanguage.verify_button || '验证') }}
          </div>
        </div>
      </div>

      <!-- 结果展示区域 -->
      <div class="result-section" v-if="showResultSection">
        <!-- 加载状态 -->
        <div v-if="isLoading" class="loading-state">
          <div class="loading-spinner"></div>
          <p>{{ globalDataArray.siteTemplateLanguage.verifying_message || '正在验证中...' }}</p>
        </div>

        <!-- 验证结果 -->
        <div v-else-if="hasVerified" class="verification-result">
          <div class="result-container" :class="{ 'valid': verificationResult.isValid, 'invalid': !verificationResult.isValid }">
            <div class="result-icon">
              <div v-if="verificationResult.isValid" class="valid-icon">✓</div>
              <div v-else class="invalid-icon">✗</div>
            </div>
            <div class="result-content">
              <h2 class="result-title">
                {{ verificationResult.isValid ?
                  (globalDataArray.siteTemplateLanguage.certificate_valid || '证书有效') :
                  (globalDataArray.siteTemplateLanguage.certificate_invalid || '证书无效') }}
              </h2>
              <p class="result-message">
                {{ verificationResult.isValid ?
                  (globalDataArray.siteTemplateLanguage.certificate_verification_success_message || '证书验证成功，该证书为有效证书') :
                  (globalDataArray.siteTemplateLanguage.certificate_verification_failed_message || '证书验证失败，未找到有效证书或证书信息不完整') }}
              </p>
              <div class="certificate-info" v-if="verificationResult.isValid">
                <p><strong>{{ globalDataArray.siteTemplateLanguage.name_text || '姓名' }}:</strong> {{ searchForm.name }}</p>
                <p><strong>{{ globalDataArray.siteTemplateLanguage.certificate_number_label || '证书编号' }}:</strong> {{ searchForm.certificateNumber }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 初始状态 -->
        <div v-else class="default-state">
          <div class="logo-container">
            <img :src="logoUrl" alt="OpenAtom Foundation" class="foundation-logo">
          </div>
          <p class="initial-message">
            {{ globalDataArray.siteTemplateLanguage.verify_instruction || '请输入姓名和证书编号进行真伪验证' }}
          </p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { verifyCertificate } from '@/api/more/certificate'
import Cookies from 'js-cookie'

export default {
  name: 'CertificateVerify',
  data() {
    return {
      searchForm: {
        name: '',
        certificateNumber: ''
      },
      verificationResult: {
        isValid: false,
        message: ''
      },
      isLoading: false,
      hasVerified: false,
      validationErrors: {
        name: '',
        certificateNumber: ''
      },
      isMobile: this.$isServer ? false : window.innerWidth < 768,
      showResultSection: false
    }
  },
  computed: {
    logoUrl() {
      return require('@/assets/images/certificate/logo.png')
    }
  },
  mounted() {
    // 页面加载完成后判断是否是 PC 端，如果是则显示结果区域
    this.showResultSection = !this.isMobile
  },
  methods: {
    async handleVerify() {
      let token = ''
      const saitiAccessInfo = Cookies.get('saiti_access_info')
      if (saitiAccessInfo != '' && saitiAccessInfo != undefined && saitiAccessInfo != null) {
        token = JSON.parse(saitiAccessInfo).token
      }
      if (token !== '' && token !== undefined) {
        // 清除之前的验证错误
        this.validationErrors = {
          name: '',
          certificateNumber: ''
        }
        let hasError = false
        if (!this.searchForm.name.trim()) {
          this.validationErrors.name = this.globalDataArray.siteTemplateLanguage.please_enter_name || '请输入姓名'
          hasError = true
        }
        if (!this.searchForm.certificateNumber.trim()) {
          this.validationErrors.certificateNumber = this.globalDataArray.siteTemplateLanguage.certificate_number_placeholder || '请输入证书编号'
          hasError = true
        }
        if (hasError) {
          return
        }
        this.showResultSection = true
        this.isLoading = true
        this.hasVerified = false
        try {
          const result = await verifyCertificate({
            name: this.searchForm.name.trim(),
            certificateNumber: this.searchForm.certificateNumber.trim()
          })
          this.hasVerified = true
          if (result.code === 200 && result.data) {
            this.verificationResult = result.data
          } else {
            this.verificationResult = {
              isValid: false,
              message: this.globalDataArray.siteTemplateLanguage.certificate_verification_failed_message || '证书验证失败，未找到有效证书或证书信息不完整'
            }
          }
        } catch (error) {
          console.error('验证证书失败:', error)
          this.hasVerified = true
          this.verificationResult = {
            isValid: false,
            message: this.globalDataArray.siteTemplateLanguage.verify_failed || '验证失败，请稍后重试'
          }
        } finally {
          this.isLoading = false
        }
      } else {
        this.handleLogin()
      }
    },
    handleLogin() {
      const redirectUrl = encodeURIComponent(location.href)
      Cookies.set('atom_redirect', redirectUrl, { domain: '.atomgit.com', expires: 180, path: '/', secure: true })
      location.href = this.logAuthUrl
    },
    clearValidationError(field) {
      this.validationErrors[field] = ''
    }
  },
  metaInfo() {
    const title = this.globalDataArray?.siteInfo?.title || (this.globalDataArray?.siteTemplateLanguage?.certificate_verify || '证书真伪验证')
    const description = this.globalDataArray?.siteInfo?.description || (this.globalDataArray?.siteTemplateLanguage?.certificate_verify_description || '开放原子开源基金会证书真伪验证系统')
    const keywords = this.globalDataArray?.siteInfo?.keywords || (this.globalDataArray?.siteTemplateLanguage?.certificate_verify_keywords || '证书验证,真伪验证,开放原子,开源基金会')

    return {
      title: title,
      meta: [
        { vmid: 'description', name: 'description', content: description },
        { vmid: 'keywords', name: 'keywords', content: keywords }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.certificate-verify-page {
  position: relative;
  min-height: 100vh;
  background: #EFF6FE;

  .content-wrapper {
    position: relative;
    max-width: 1400px;
    margin: 0 auto;
    padding: 60px 40px;
    min-height: calc(100vh - 120px);
    display: flex;
    flex-direction: column;

    // 内容区域的蒙版背景
    .content-mask {
      position: absolute;
      top: 30px;
      left: 0;
      right: 0;
      bottom: 30px;
      margin: auto;
      width: 86%;
      background-image: url('@/assets/images/certificate/Certificate-mask.svg');
      background-repeat: repeat;
      opacity: 1.04;
      z-index: 0;
      pointer-events: none;
      border-radius: 20px;
    }

    // 确保所有内容在蒙版之上
    > * {
      position: relative;
      z-index: 1;
    }

    .page-title {
      text-align: center;
      font-size: 42px;
      font-weight: 600;
      color: #333;
      letter-spacing: 2px;
    }

    .search-container {
      background: transparent;
      border-radius: 20px;
      padding: 30px 60px;
      width: 89%;
      margin: auto;

      .form-row {
        display: flex;
        gap: 20px;
        margin-bottom: 0;
        align-items: center;

        .form-item {
          flex: 1;
          display: flex;
          flex-direction: row;
          align-items: center;

          label {
            font-size: 16px;
            font-weight: 500;
            color: #333;
            margin-bottom: 0;
            margin-right: 15px;
            text-align: left;
            white-space: nowrap;
            min-width: 80px;
          }

          .input-wrapper {
            position: relative;
            flex: 1;

            .form-input {
              padding: 12px 16px;
              border: 1px solid #ddd;
              border-radius: 6px;
              font-size: 14px;
              background: rgba(255, 255, 255, 0.95);
              transition: border-color 0.2s ease;
              width: 100%;
              flex: 1;

              &:focus {
                outline: none;
                border-color: #4A90E2;
                background: #fff;
              }

              &.error {
                border-color: #ff4757;
                background: rgba(255, 71, 87, 0.05);
              }

              &::placeholder {
                color: #999;
              }
            }

            .error-message {
              position: absolute;
              top: 100%;
              left: 0;
              right: 0;
              color: #ff0000;
              font-size: 12px;
              margin-top: 5px;
            }
          }
        }
      }
    }

    // 全局按钮样式
    .btn {
      cursor: pointer;
      line-height: 3;
      border-radius: 4px;
      display: inline-block;
      margin: 0;
      min-width: 80px;
      padding: 0 1em;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      transition: all 0.3s ease;
      flex-shrink: 0;
      border: none;
      outline: none;
      text-decoration: none;

      &:hover:not(.disabled) {
        text-decoration: underline;
        color: inherit;
      }

      &.disabled {
        opacity: 0.7;
        cursor: not-allowed;
        pointer-events: none;
      }
    }

    .btn1 {
      color:#ffffff;
      background:#1281ff;
    }

    .result-section {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 500px;
    }

    .loading-state {
      text-align: center;

      .loading-spinner {
        width: 60px;
        height: 60px;
        border: 5px solid #f3f3f3;
        border-top: 5px solid #4A90E2;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin: 0 auto 30px;
      }

      p {
        color: #666;
        font-size: 20px;
      }
    }

    .verification-result {
      text-align: center;
      max-width: 600px;
      width: 100%;

      .result-container {
        background: rgba(255, 255, 255, 0.95);
        border-radius: 20px;
        padding: 40px;
        box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease;

        &.valid {
          border: 3px solid #52c41a;
          .result-icon .valid-icon {
            background: #52c41a;
            color: white;
          }
        }

        &.invalid {
          border: 3px solid #ff4757;
          .result-icon .invalid-icon {
            background: #ff4757;
            color: white;
          }
        }

        .result-icon {
          margin-bottom: 30px;

          .valid-icon, .invalid-icon {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 40px;
            font-weight: bold;
            margin: 0 auto;
            transition: all 0.3s ease;
          }
        }

        .result-content {
          .result-title {
            font-size: 28px;
            font-weight: 600;
            margin-bottom: 15px;
            color: #333;
          }

          .result-message {
            font-size: 16px;
            color: #666;
            margin-bottom: 20px;
            line-height: 1.5;
          }

          .certificate-info {
            background: #f8f9fa;
            border-radius: 10px;
            padding: 20px;
            text-align: left;

            p {
              margin: 8px 0;
              font-size: 14px;
              color: #333;

              strong {
                color: #4A90E2;
                margin-right: 8px;
              }
            }
          }
        }
      }
    }

    .default-state {
      text-align: center;
      max-width: 600px;

      .logo-container {
        margin-bottom: 50px;

        .foundation-logo {
          width: 140px;
          height: 140px;
          object-fit: contain;
        }
      }

      .initial-message {
        font-size: 20px;
        color: #666;
        line-height: 1.6;
        margin: 0;
      }
    }
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

// 响应式设计
@media (max-width: 1024px) {
  .certificate-verify-page {
    .content-wrapper {
      padding: 60px 30px;

      .page-title {
        font-size: 36px;
        margin-bottom: 60px;
      }

      .search-container {
        padding: 40px 30px;
        max-width: 800px;

        .form-row {
          gap: 30px;
        }
      }

      .result-section {
        .verification-result {
          padding: 40px 30px;
        }

        .default-state {
          .logo-container .foundation-logo {
            width: 120px;
            height: 120px;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .certificate-verify-page {
    .content-wrapper {
      padding: 40px 20px;

      .page-title {
        font-size: 28px;
        margin-bottom: 40px;
      }

      .search-container {
        padding: 30px 20px;

        .form-row {
          flex-direction: column;
          gap: 20px;
          align-items: stretch;

          .form-item {
            .form-input {
              padding: 14px 16px;
            }
          }
        }

        .btn {
          padding: 12px 24px;
          min-width: 100px;
        }
      }

      .result-section {
        min-height: 400px;

        .default-state {
          .logo-container .foundation-logo {
            width: 100px;
            height: 100px;
          }

          .initial-message {
            font-size: 16px;
          }
        }

        .verification-result {
          padding: 30px 20px;

          .result-container {
            padding: 30px 20px;

            .result-icon {
              .valid-icon, .invalid-icon {
                width: 60px;
                height: 60px;
                font-size: 30px;
              }
            }

            .result-content {
              .result-title {
                font-size: 24px;
              }

              .result-message {
                font-size: 14px;
              }

              .certificate-info {
                padding: 15px;

                p {
                  font-size: 13px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
